export class Controller {

    $onChanges() {
        this.tooltipKey = ({
            AD: 'sp-account-type.active-directory',
            EXTERNAL_EMAIL: 'sp-account-type.external-email',
            INTERNAL_EMAIL: 'sp-account-type.internal-email',
            PHONENUMBER: 'sp-account-type.phone-number',
            SHARED_EMAIL: 'sp-account-type.shared-email',
            SIMPLE_USERNAME: 'sp-account-type.simple-username',
        })[this.accountType];

        this.iconClass = ({
            AD: 'text-primary fa fa-database',
            EXTERNAL_EMAIL: 'text-primary fa-lg fas fa-envelope',
            INTERNAL_EMAIL: 'text-primary fa-lg far fa-envelope',
            PHONENUMBER: 'text-primary fa-lg fas fa-phone',
            SHARED_EMAIL: 'text-primary fa-lg fas fa-share-alt',
            SIMPLE_USERNAME: 'text-primary fa-lg far fa-address-card',
        })[this.accountType];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-account-type/sp-account-type.controller.js